import { AppState, PageProps, Session } from "@declarations"
import { getVisitors } from "Store/Actions/DataActions-VisitorBehavior"
import Table from "Components/Table/Table"
import { useEffect } from "react"
import Skeleton from "react-loading-skeleton"
import { connect } from "react-redux"
import { store } from "Store/store"
import EmptyState from "Components/EmptyState/EmptyState"
import { callCheck } from "Utils/data"

interface Props extends PageProps<typeof mapStateToProps, typeof mapDispatchToProps> {
}

const VisitorsTable = (props: Props) => {

    const { session, globalView, experiences, dataList, getDataList, loadingData, demoBrandActive } = props

    useEffect(() => {

        if (!callCheck(globalView, (session as Session.AuthSession).user.admin, experiences?.length)) return

        getDataList()

    }, [experiences, getDataList, session, demoBrandActive, globalView])

    return (
        <div >
            {
                loadingData
                    ? <Skeleton height={500} className="table-skeleton-shared-box" />
                    : dataList && dataList.length
                        ? <Table
                            title="Visitors"
                            titleTooltip=""
                            showTitle={false}
                            headers={Object.keys(dataList[0])}
                            sortable={["scans", "sessions"]}
                            tooltipable={[
                                { header: "scans", text: "These are defined as an individual instance where a visitor scans a QR code." },
                                { header: "sessions", text: "These are defined as when a visitor spends 10+ seconds viewing an experience." }
                            ]}
                            data={dataList}
                            limit={20}
                            pagination={true}
                        />
                        : <EmptyState filterableData={false} />
            }
        </div>
    )
}

const mapStateToProps = (state: AppState) => {
    return {
        session: state.session,
        experiences: state.experiences.experienceIdList,
        globalView: state.experiences.globalView,
        demoBrandActive: state.experiences.demoBrandActive,
        dataList: state.data.visitorBehavior.visitors.visitors,
        loadingData: state.loading.visitorBehavior.visitors.visitors
    }
}
const mapDispatchToProps = (dispatch: typeof store.dispatch) => {
    return {
        getDataList: () => dispatch(getVisitors())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VisitorsTable)